import { environment } from '../../../../environments/environment';

export function CompanyWebsiteAvailableValidatorDirective($q, $http) {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      ngModel.$asyncValidators.companyWebsiteAvailable = function (modelValue) {
        if (modelValue !== attrs.companyWebsiteAvailableValidator) {
          return $http.get(
            environment.apiEndpoint + 'sessions/check_company_website?q=' + modelValue
          );
        }

        return $q.resolve(true);
      };
    },
  };
}

CompanyWebsiteAvailableValidatorDirective.$inject = ['$q', '$http'];

// export const CompanyWebsiteAvailableValidatorDirective = ($q, $http) => {
